/* RURU product section — behaviour (Shopify-safe, no custom elements). */
(function () {
  function init(root) {
    root = root || document;
    var $  = function (s, r) { return (r || root).querySelector(s); };
    var $$ = function (s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); };

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* --- Reveal on scroll --- */
    var reveals = $$('[data-pp-reveal]');
    if (reduce) {
      reveals.forEach(function (el) { el.classList.add('is-visible'); });
    } else {
      reveals.forEach(function (el) {
        if (el.getBoundingClientRect().top < window.innerHeight * 0.95) el.classList.add('is-visible');
      });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); } });
      }, { threshold: 0, rootMargin: '0px 0px -8% 0px' });
      reveals.forEach(function (el) { if (!el.classList.contains('is-visible')) io.observe(el); });
      setTimeout(function () {
        reveals.forEach(function (el) {
          if (getComputedStyle(el).opacity !== '1') {
            el.style.transition = 'none';
            el.classList.add('is-visible');
            el.style.opacity = '1'; el.style.transform = 'none'; el.style.filter = 'none';
          }
        });
      }, 1200);
    }

    /* --- Count-up --- */
    var fmt = function (n) { return n >= 1000 ? n.toLocaleString('en-US') : String(n); };
    var animCount = function (el) {
      var target = parseFloat(el.getAttribute('data-countup'));
      if (!isFinite(target)) return;
      if (reduce) { el.textContent = fmt(target); return; }
      var dur = 1400, start = 0;
      var step = function (t) {
        if (!start) start = t;
        var p = Math.min(1, (t - start) / dur);
        el.textContent = fmt(Math.round(target * (1 - Math.pow(1 - p, 3))));
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { animCount(e.target); cio.unobserve(e.target); } });
    }, { threshold: 0.5 });
    $$('[data-countup]').forEach(function (el) { cio.observe(el); });

    /* --- Gallery --- */
    var stage = $('#gallery-stage');
    var tones = ['pp-gallery-bg-tone-1', 'pp-gallery-bg-tone-2', 'pp-gallery-bg-tone-3', 'pp-gallery-bg-tone-4'];
    $$('.pp-thumb').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.getAttribute('data-thumb'), 10);
        $$('.pp-thumb').forEach(function (b) { b.classList.toggle('active', b === btn); });
        $$('.pp-gallery-slot').forEach(function (s) { s.classList.toggle('active', parseInt(s.getAttribute('data-gi'), 10) === idx); });
        if (stage) tones.forEach(function (c, i) { stage.classList.toggle(c, i === idx); });
      });
    });

    /* --- Quantity + price total --- */
    var priceEl = $('[data-price-base]');
    var base = priceEl ? parseFloat(priceEl.getAttribute('data-price-base')) || 0 : 0;
    var sym = priceEl ? priceEl.getAttribute('data-price-symbol') || '' : '';
    var pos = priceEl ? priceEl.getAttribute('data-price-pos') || 'after' : 'after';
    var money = function (n) {
      var v = (Math.round(n * 100) / 100).toLocaleString('en-US');
      return pos === 'before' ? (sym + v) : (v + ' ' + sym);
    };
    var qty = 1;
    var qd = $('[data-qty-display]');
    var setQty = function () {
      if (qd) qd.textContent = qty;
      $$('[data-price-qty]').forEach(function (el) { el.textContent = money(base * qty); });
    };
    var minus = $('[data-qty-minus]'); var plus = $('[data-qty-plus]');
    if (minus) minus.addEventListener('click', function () { if (qty > 1) { qty--; setQty(); } });
    if (plus)  plus.addEventListener('click', function () { if (qty < 9) { qty++; setQty(); } });
    setQty();

    /* --- Add to cart toast --- */
    var toast = $('#toast'), toastMsg = $('#toast-msg'), tt;
    var rootEl = root.querySelector ? (root.querySelector('.ruru-product') || document.querySelector('.ruru-product')) : document.querySelector('.ruru-product');
    var variantId = rootEl ? rootEl.getAttribute('data-variant-id') : '';
    var goToCart = rootEl ? rootEl.getAttribute('data-go-to-cart') === 'true' : false;

    var showToast = function () {
      if (toast) {
        if (toastMsg) toastMsg.textContent = qty + ' × ' + (toast.getAttribute('data-name') || 'RURU') + ' added to cart';
        toast.classList.add('visible');
        clearTimeout(tt);
        tt = setTimeout(function () { toast.classList.remove('visible'); }, 2200);
      }
    };

    var addToCart = function (btn) {
      if (!variantId) { showToast(); return; }
      if (btn) btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: qty })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed ' + r.status);
        return r.json();
      }).then(function () {
        if (btn) btn.disabled = false;
        showToast();
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:open'));
        // Update any visible cart count bubbles
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) {
            document.querySelectorAll('.cart-count-bubble, [data-cart-count]').forEach(function (b) { b.textContent = c.item_count; });
          }).catch(function () {});
        if (goToCart) window.location.href = '/cart';
      }).catch(function () {
        // Hard fallback: submit a real form POST that always works on Shopify.
        if (btn) btn.disabled = false;
        var f = document.createElement('form');
        f.method = 'post';
        f.action = '/cart/add';
        f.style.display = 'none';
        f.innerHTML = '<input type="hidden" name="id" value="' + variantId + '"><input type="hidden" name="quantity" value="' + qty + '">';
        document.body.appendChild(f);
        f.submit();
      });
    };

    $$('[data-add-to-cart]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (variantId) { e.preventDefault(); addToCart(btn); }
        else { showToast(); }
      });
    });

    /* --- Sticky bar --- */
    var sticky = $('#stickybar');
    if (sticky) {
      var onScroll = function () { sticky.classList.toggle('visible', window.scrollY > 700); };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    /* --- Capability tabs --- */
    var tabs = $$('.pp-cap-tab');
    var bg = $('#cap-bg'), corner = $('#cap-corner'), label = $('#cap-label'), text = $('#cap-text');
    var capImg = $('#cap-img-el'), capImgWrap = $('#cap-img'), capDisplay = $('#cap-display');
    var idx = 0, raf = 0, startT = 0, paused = false;
    var SLIDE = 5500;
    var setCap = function (i) {
      idx = i;
      tabs.forEach(function (t, j) {
        t.classList.toggle('active', j === i);
        var p = t.querySelector('.progress'); if (p) p.style.width = '0%';
      });
      var tab = tabs[i]; if (!tab) return;
      if (corner) corner.textContent = tab.getAttribute('data-badge') || '';
      if (label)  label.textContent  = tab.getAttribute('data-label') || '';
      if (text)   text.textContent   = tab.getAttribute('data-overlay') || '';
      var fit = tab.getAttribute('data-fit') || 'contain';
      var src = tab.getAttribute('data-img');
      if (capImg && src) { capImg.src = src; capImg.style.objectFit = fit; }
      if (bg) bg.className = 'pp-cap-bg tone-' + (tab.getAttribute('data-tone') || 'mustard');
      if (capImgWrap) capImgWrap.classList.toggle('fit-cover', fit === 'cover');
      if (capDisplay) capDisplay.classList.toggle('has-photo', fit === 'cover');
    };
    var stepCap = function (t) {
      if (paused) { raf = requestAnimationFrame(stepCap); return; }
      if (!startT) startT = t;
      var p = Math.min(1, (t - startT) / SLIDE);
      var pe = tabs[idx] && tabs[idx].querySelector('.progress');
      if (pe) pe.style.width = (p * 100) + '%';
      if (p >= 1) { startT = t; setCap((idx + 1) % tabs.length); }
      raf = requestAnimationFrame(stepCap);
    };
    tabs.forEach(function (tab, i) { tab.addEventListener('click', function () { startT = 0; setCap(i); }); });
    if (tabs.length) {
      setCap(0);
      var cap = $('#capabilities');
      if (cap) {
        cap.addEventListener('mouseenter', function () { paused = true; });
        cap.addEventListener('mouseleave', function () { paused = false; startT = 0; });
        var capIO = new IntersectionObserver(function (e) {
          if (e[0].isIntersecting && !raf) { startT = 0; raf = requestAnimationFrame(stepCap); }
          else if (!e[0].isIntersecting && raf) { cancelAnimationFrame(raf); raf = 0; }
        }, { threshold: 0.2 });
        capIO.observe(cap);
      }
    }

    /* --- FAQ --- */
    $$('[data-faq-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.pp-faq-item');
        var open = item.classList.contains('open');
        $$('.pp-faq-item').forEach(function (it) { it.classList.remove('open'); });
        if (!open) item.classList.add('open');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  // Re-init inside Shopify theme editor when section is reloaded
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
